import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { StoreSettingsCollectionModel } from "@store/Services/SettingsService";

export const getStoreSettingsCollection = (state: ApplicationState) => {
    return state.context.settings.settingsCollection as StoreSettingsCollectionModel;
};

export const getState = (state: ApplicationState) => {
    return state;
};
